
import {environment} from './environment';

export const DATA_DB = "mlVsTaS1zk4DJg6sOl_QrgRx8ryNbJ";

export const db = {
    getDB,
    get,
    save,
    remove,
    update,
    newObject,
    newGeometryUser
};

function getDB(){
    let db = localStorage.getItem(DATA_DB);
    if(db === null || db === undefined){
        db = {
            db: 'local',
            requirements: [],
            buffers: []
        };
    }else{
        db = JSON.parse(db);
    }
    return db;
}

function newObject(typeObj){
    return {
        id: null,
        name: null,
        type: typeObj,
        user: environment.getUser(),
        cidade: null,
        estado: null,
        substancia: null,
        substanciaUso: null,
        description: '',
        cidadeDivisa: '',
        color: '',
        colorRGB: '',
        status: 'ATIVO',
        deleted: false,
        createdAt: '',
        updatedAt: '',
        syncAt: '',
        geometryUser: null,
    };
}

function newGeometryUser(typeObj){
    return {
        id: null,
        type: typeObj,
        cidade: null,
        estado: null,
        bbox: null,
        bboxList: null,
        point: null,
        coordinates: null,
        coordinatesList: null,
        coordinatesMulti: null,
        coordinatesMultiList: null,
        dms: '',
        acres: 0,
        hectares: 0,
        pointLatLng: null,
        status: 'ATIVO',
        deleted: false,
        createdAt: '',
        updatedAt: ''
    };
}

function get(name = null, type = 'REQUERIMENTO'){
    let db = this.getDB();
    let obj = null;
    switch (type) {
        case 'REQUERIMENTO':
            for(let i = 0; i < db.requirements.length; i++){
                if(db.requirements[i].name === name){
                    obj = db.requirements[i];
                    break;
                }
            }
        break;
        case 'BUFFER':
            for(let i = 0; i < db.buffers.length; i++){
                if(db.buffers[i].name === name){
                    obj = db.buffers[i];
                    break;
                }
            }
        break;
    }
    return obj;
}

function save(name = null, cidadeDivisa = '', list, type = 'REQUERIMENTO'){
    let db = getDB();
    let obj = this.newObject(type);
    let saveOK = false;
    switch (type) {
        case 'REQUERIMENTO':
            if(list.length > 0){
                obj.name = name;
                obj.cidadeDivisa = cidadeDivisa;
                obj.geometryUser = [];
                if(list.length > 1){
                    let bbox = [];
                    let coordinatesMulti = [];
                    let dmsList = "";
                    obj.geometryUser.push(this.newGeometryUser(type));
                    for(let j = 0; j < list.length; j++){
                        let coordList = [];
                        let rings = list[j].graphic.geometry.rings[0];
                        for(let i = 0; i < rings.length; i++){
                            coordList.push({
                                lat: rings[i][1],
                                lng: rings[i][0]
                            });
                            if(bbox.length < 2){
                                bbox.push(coordList[i]);
                            }
                        }
                        coordinatesMulti.push(coordList);
                        dmsList += list[j].dms + ",";

                        obj.geometryUser[0].acres += parseFloat(list[j].acres);
                        obj.geometryUser[0].hectares += parseFloat(list[j].hectares);
                    }
                    obj.geometryUser[0].bboxList = bbox;
                    obj.geometryUser[0].coordinatesMultiList = coordinatesMulti;
                    obj.geometryUser[0].dms = dmsList;
                }else{
                    obj.geometryUser = [];
                    let bbox = [];
                    let coordList = [];
                    let rings = list[0].graphic.geometry.rings[0];
                    for(let i = 0; i < rings.length; i++){
                        coordList.push({
                            lat: rings[i][1],
                            lng: rings[i][0]
                        });
                        if(bbox.length < 2){
                            bbox.push(coordList[i]);
                        }
                    }
                    obj.geometryUser.push(this.newGeometryUser(type));
                    obj.geometryUser[0].bboxList = bbox;
                    obj.geometryUser[0].coordinatesList = coordList;
                    obj.geometryUser[0].dms = list[0].dms;
                    obj.geometryUser[0].acres = list[0].acres;
                    obj.geometryUser[0].hectares = list[0].hectares;
                }
                if(db.requirements === null || db.requirements === undefined){
                    db.requirements = [];
                }
                if(db.requirements.length > 0){
                    let dados = [];
                    let exists = false;
                    for(let i = 0; i < db.requirements.length; i++){
                        if(db.requirements[i].name === name){
                            dados.push(obj);
                            exists = true;
                        }else{
                            dados.push(db.requirements[i]);
                        }
                    }
                    if(!exists){
                        dados.push(obj);
                    }
                    db.requirements = dados;
                }else{
                    db.requirements.push(obj);
                }
                // console.log(obj);
                saveOK = true;
            }
        break;
        case 'BUFFER':
            console.log(list);
            if(list.length > 0){
                obj.name = name;
                obj.cidadeDivisa = cidadeDivisa;
                obj.geometryUser = [];
                let index = 0;
                for(let j = 0; j < list.length; j++){
                    let bbox = [];
                    let coordList = [];
                    let geometry = list[j].graphic.geometry;

                    if(geometry.type === "polygon"){
                        let rings = geometry.rings[0];
                        for(let i = 0; i < rings.length; i++){
                            coordList.push({
                                lat: rings[i][1],
                                lng: rings[i][0]
                            });
                            if(bbox.length < 2){
                                bbox.push(coordList[i]);
                            }
                        }

                        obj.geometryUser.push(this.newGeometryUser(type));
                        obj.geometryUser[index].bboxList = bbox;
                        obj.geometryUser[index].coordinatesList = coordList;
                        obj.geometryUser[index].dms = list[j].dms;
                        obj.geometryUser[index].acres = list[j].acres;
                        obj.geometryUser[index].hectares = list[j].hectares;

                        index++;
                    }else if(geometry.type === "polyline"){
                        let paths = geometry.paths[0];
                        for(let i = 0; i < paths.length; i++){
                            bbox.push({
                                lat: paths[i][1],
                                lng: paths[i][0]
                            });
                        }

                        obj.geometryUser.push(this.newGeometryUser(type));
                        obj.geometryUser[index].bboxList = bbox;
                        obj.geometryUser[index].dms = list[j].dms;
                        obj.geometryUser[index].acres = list[j].acres;
                        obj.geometryUser[index].hectares = list[j].hectares;
                        index++;
                    }else{
                        let pointLatLng = {
                            lat: geometry.latitude,
                            lng: geometry.longitude
                        };
                        obj.geometryUser.push(this.newGeometryUser(type));
                        obj.geometryUser[index].pointLatLng = pointLatLng;
                        obj.geometryUser[index].dms = list[j].dms;
                        obj.geometryUser[index].acres = list[j].acres;
                        obj.geometryUser[index].hectares = list[j].hectares;
                        index++;
                    }
                    
                }
                if(db.buffers === null || db.buffers === undefined){
                    db.buffers = [];
                }
                if(db.buffers.length > 0){
                    let dados = [];
                    let exists = false;
                    for(let i = 0; i < db.buffers.length; i++){
                        if(db.buffers[i].name === name){
                            dados.push(obj);
                            exists = true;
                        }else{
                            dados.push(db.buffers[i]);
                        }
                    }
                    if(!exists){
                        dados.push(obj);
                    }
                    db.buffers = dados;
                }else{
                    db.buffers.push(obj);
                }
                saveOK = true;
            }
        break;
    }
    localStorage.setItem(DATA_DB, JSON.stringify(db));
    return saveOK;
}

function remove(name = null, type = 'REQUERIMENTO'){
    if(name !== null){
        let db = this.getDB();
        switch (type) {
            case 'REQUERIMENTO':
                let requirements = [];
                for(let i = 0; i < db.requirements.length; i++){
                    if(db.requirements[i].name !== name){
                        requirements.push(db.requirements[i]);
                    }
                }
                db.requirements = requirements;
            break;
            case 'BUFFER':
                let buffers = [];
                for(let i = 0; i < db.buffers.length; i++){
                    if(db.buffers[i].name !== name){
                        buffers.push(db.buffers[i]);
                    }
                }
                db.buffers = buffers;
            break;
        }
        localStorage.setItem(DATA_DB, JSON.stringify(db));
    }
}

function update(db){
    localStorage.setItem(DATA_DB, JSON.stringify(db));
}